import React from 'react';
import _ from 'lodash';

import WorkerSettingsContext from '../../services/workerSettings/WorkerSettingsContext';
import Tippy from '../../components/ReactTippy';
import { Confirmation, Information } from '../modals/common/';
import { FileUpload } from '../image/FileUpload';
import { messageUtility } from '../../utilities/messageUtility';
import {
  SORT_TYPE,
  WORKER_IMAGE_REGISTER_STATUS,
  WORKER_IMAGE_CCUS_SYNCED_STATUS,
  DIALOG_STATUS,
  WORKER_SETTING_STATUS,
} from '../../utilities/constants';
import Styles from '../../styles/componentStyle/workerSettings/WorkerSettings.scss';

/**
 * 作業員設定状況一覧 (顔写真)データテーブル
 * */
export const FacePictureTableLayout = ({ isVisibleThumbnails }) => {
  // 画面表示
  return (
    <WorkerSettingsContext.Consumer>
      {({
        state,
        changeSort,
        closeDialog,
        closeImageSettingErrorDialog,
        closeImageSettingDialog,
        updateFacePicture,
      }) => (
        <div className={`${Styles.facePictureTable} master-slide-view__body`}>
          <table className='table'>
            <thead className='table__header'>
              <tr className='table__label'>
                {data.tableTitles.map((title, index) => (
                  <th
                    className='value-table value-table--table__label'
                    key={index}
                    onClick={() => {
                      if (title.doSort === true) {
                        changeSort(title.name);
                      }
                    }}
                  >
                    <div className='value-table__label'>
                      <span
                        className={`${
                          title.doSort !== true
                            ? 'value-table__label-no-sort-icon'
                            : 'value-table__label-with-sort-icon'
                        }`}
                      >
                        {title.label}
                        {state.searchForm.order === title.name &&
                          state.searchForm.sortType === SORT_TYPE.asc.id && (
                            <button className='btn-icon--xs--dark'>
                              <i className='i-sortaz i-1x' />
                            </button>
                          )}
                        {state.searchForm.order === title.name &&
                          state.searchForm.sortType === SORT_TYPE.desc.id && (
                            <button className='btn-icon--xs--dark'>
                              <i className='i-sortza i-1x' />
                            </button>
                          )}
                        {title.doSort === true &&
                          state.searchForm.order !== title.name && (
                            <button className='btn-icon--xs--dark btn-icon__sort btn-icon__sort--low-opacity'>
                              <i className='i-sortdefault i-1x' />
                            </button>
                          )}
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className='table__body'>
              {state.workerList.map((item, index) => (
                <FixItems
                  worker={item}
                  key={index}
                  isVisibleThumbnails={isVisibleThumbnails}
                />
              ))}
            </tbody>
          </table>

          {/* 作業員設定状況詳細ダイアログ */}
          <Information
            visible={
              state.dialogStatus === DIALOG_STATUS.confirmDialogEnabled.id
            }
            title={data.confirmDialog.title}
            buttonText={data.confirmDialog.close}
            message={<ConfirmDialogMessage />}
            onClose={() => closeDialog()}
            rootClassName='ImageFileUploadDetail'
          />

          {/* 顔写真選択時エラーダイアログ */}
          <Information
            visible={state.showImageSettingErrorDialog === true}
            title={state.informationModal.title}
            message={state.informationModal.message}
            buttonText={state.informationModal.buttonText}
            onClose={() => closeImageSettingErrorDialog()}
            rootClassName='ImageUploadDialog'
            multilineText={true}
          />

          {/* 作業員画像設定詳細ダイアログ */}
          <Confirmation
            visible={
              state.dialogStatus === DIALOG_STATUS.imageSettingDialogEnabled.id
            }
            title={data.imageSettingDialog.title}
            confirmButtonText={data.imageSettingDialog.buttonTitle.update}
            cancelButtonText={data.imageSettingDialog.buttonTitle.cancel}
            message={<ImageSettingDialogMessage />}
            isNegative={true}
            onCancel={() => closeImageSettingDialog()}
            onConfirm={() => updateFacePicture()}
            rootClassName='ImageFileUpload'
            negativeButtonClassName={
              state.isLoading
                ? 'btn--effective btn--disabled'
                : 'btn--effective'
            }
          />
        </div>
      )}
    </WorkerSettingsContext.Consumer>
  );
};

/**
 * 作業員設定状況一覧 (顔写真)データ表示
 * */
const FixItems = ({ worker, isVisibleThumbnails }) => {
  const getWorkerImage = () => {
    if (
      isVisibleThumbnails &&
      worker.worker_image_register_status ===
        WORKER_IMAGE_REGISTER_STATUS.register.id
    ) {
      return (
        <div className='table__item-thumbnail'>
          <div className='table__item-thumbnail__content'>
            <img src={worker.worker_thumbnail_image_url} />
          </div>
        </div>
      );
    }

    const status = _.find(
      WORKER_IMAGE_REGISTER_STATUS,
      item => worker.worker_image_register_status === item.id
    );

    return (
      <span key={status.id} className={status.className}>
        {_.get(status, 'name')}
      </span>
    );
  };
  // 画面表示
  return (
    <WorkerSettingsContext.Consumer>
      {({ showDetailDialog }) => (
        <tr className='table__item'>
          {/*/!*所属会社*!/*/}
          <td className='gate-list-value-table__name'>
            <WithTooltip>{worker.company_name}</WithTooltip>
          </td>
          {/*/!*一次協力会社*!/*/}
          <td className='gate-list-value-table__name'>
            <WithTooltip>{worker.primary_company_name}</WithTooltip>
          </td>
          {/*/!*作業員名*!/*/}
          <td className='gate-list-value-table__name value-table__worker-name'>
            <WithTooltip>
              <span>
                <span className='fullname-kana'>{worker.fullname_kana}</span>{' '}
                <br />
                <span className='name-kanji'>{worker.fullname}</span>
              </span>
            </WithTooltip>
          </td>
          {/*/!*ステータス*!/*/}
          <td className='gate-list-value-table__name'>
            {_.map(WORKER_SETTING_STATUS, item => {
              if (worker.worker_status === item.ID) {
                const content = <span key={item.ID}>{item.NAME}</span>;
                return content;
              }
            })}
          </td>
          {/*/!*顔写真*!/*/}
          <td className='gate-list-value-table__name'>{getWorkerImage()}</td>
          {/*/!*顔写真送信*!/*/}
          <td className='gate-list-value-table__name'>
            {_.map(WORKER_IMAGE_CCUS_SYNCED_STATUS, item => {
              if (worker.worker_image_info.ccusSyncedStatus === item.id) {
                const content = <span key={item.id}>{item.name}</span>;
                if (worker.worker_image_info.allCcusSyncedStatuses.length > 0) {
                  const tooltipContent = worker.worker_image_info.allCcusSyncedStatuses.map(
                    (item, index) => <p key={index}>{item.formatted}</p>
                  );
                  return (
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[100, 0]}
                      placement='bottom'
                      followCursor={true}
                      html={
                        <div className={Styles.toopTip}>{tooltipContent}</div>
                      }
                    >
                      {content}
                    </Tippy>
                  );
                } else {
                  return content;
                }
              }
            })}
          </td>
          {/*/!*送信対象外理由*!/*/}
          <td className='gate-list-value-table__name'>
            {worker.worker_image_exclusion_reason.length > 0 ? (
              worker.worker_image_exclusion_reason
            ) : (
              <p>ー</p>
            )}
          </td>
          {/*/!*エラー状況*!/*/}
          <td className='gate-list-value-table__name'>
            {worker.worker_image_info.allErrors.length > 0 ? (
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[100, 0]}
                placement='bottom'
                followCursor={true}
                html={
                  <div className={Styles.toopTip}>
                    {worker.worker_image_info.allErrors.map((item, index) => {
                      return <p key={index}>{item.formatted}</p>;
                    })}
                  </div>
                }
              >
                <p
                  className={
                    worker.worker_image_info.hasError ? 'error_message' : ''
                  }
                >
                  {worker.worker_image_info.errorMessage}
                </p>
              </Tippy>
            ) : (
              <p>ー</p>
            )}
          </td>
          {/*/!*詳細*!/*/}
          <td className='gate-list-value-table__name'>
            <button
              className='btn--stay'
              onClick={() => {
                showDetailDialog(worker);
              }}
            >
              {data.buttonTitle.confirmation}
            </button>
          </td>
        </tr>
      )}
    </WorkerSettingsContext.Consumer>
  );
};

/**
 * 作業員設定状況詳細ダイアログ
 * */
const ConfirmDialogMessage = () => {
  // 画面表示
  return (
    <WorkerSettingsContext.Consumer>
      {({ state, showImageSettingDialog }) => (
        <React.Fragment>
          <div className='detail-item image-detail'>
            <ul className='form-list image-detail__item'>
              {/*/!*作業員顔写真*!/*/}
              <li className='form-list__item image-detail__element'>
                <FileUpload imageUrl={state.detailWorker.imageUrl} />
              </li>
              <li>
                <button
                  className='btn'
                  onClick={() => {
                    showImageSettingDialog();
                  }}
                >
                  {data.imageSettingDialog.registerAndUpDate}
                </button>
              </li>
            </ul>
          </div>
          <div className='detail-item worker-detail'>
            <ul className='form-list worker-detail__item'>
              {/*/!*氏名*!/*/}
              <li className='form-list__item worker-detail__element'>
                <div className='form-item__label'>
                  <span className='label'>{data.confirmDialog.workerName}</span>
                </div>
                <div className='form-item__element'>
                  {state.detailWorker.fullName}
                </div>
              </li>
              {/*/!*所属会社*!/*/}
              <li className='form-list__item worker-detail__element'>
                <div className='form-item__label'>
                  <span className='label'>
                    {data.confirmDialog.companyName}
                  </span>
                </div>
                <div className='form-item__element'>
                  {state.detailWorker.companyName}
                </div>
              </li>
              {/*/!*一次協力会社*!/*/}
              <li className='form-list__item worker-detail__element'>
                <div className='form-item__label'>
                  <span className='label'>
                    {data.confirmDialog.primaryCompanyName}
                  </span>
                </div>
                <div className='form-item__element'>
                  {state.detailWorker.primaryCompanyName}
                </div>
              </li>
              {/*/!*作業員ステータス*!/*/}
              <li className='form-list__item worker-detail__element'>
                <div className='form-item__label'>
                  <span className='label'>
                    {data.confirmDialog.workerStatus}
                  </span>
                </div>
                <div className='form-item__element'>
                  {_.map(WORKER_SETTING_STATUS, item => {
                    if (state.detailWorker.workerStatus === item.ID) {
                      const content = <span key={item.ID}>{item.NAME}</span>;
                      return content;
                    }
                  })}
                </div>
              </li>
              {/*/!*顔認証連携*!/*/}
              <li className='form-list__item worker-detail__element'>
                <div className='form-item__label'>
                  <span className='label'>{data.confirmDialog.faceImage}</span>
                </div>
                <div className='form-item__element'>
                  {state.detailWorker.workerImageInfo.allCcusSyncedStatuses
                    .length > 0 ? (
                    state.detailWorker.workerImageInfo.allCcusSyncedStatuses.map(
                      (item, index) => <p key={index}>{item.formatted}</p>
                    )
                  ) : (
                    <p>
                      {
                        _.find(WORKER_IMAGE_CCUS_SYNCED_STATUS, {
                          id:
                            state.detailWorker.workerImageInfo.ccusSyncedStatus,
                        }).name
                      }
                    </p>
                  )}
                </div>
              </li>
              {/*/!*送信対象外理由*!/*/}
              <li className='form-list__item worker-detail__element'>
                <div className='form-item__label'>
                  <span className='label'>
                    {data.confirmDialog.exclusionReason}
                  </span>
                </div>
                <div className='form-item__element'>
                  {state.detailWorker.exclusionReason !== '' ? (
                    <p>{state.detailWorker.exclusionReason}</p>
                  ) : (
                    <p>ー</p>
                  )}
                </div>
              </li>
              {/*/!*エラー状況*!/*/}
              <li className='form-list__item worker-detail__element'>
                <div className='form-item__label'>
                  <span className='label'>{data.confirmDialog.hasError}</span>
                </div>
                <div className='form-item__element'>
                  {state.detailWorker.workerImageInfo.allErrors.length > 0 ? (
                    state.detailWorker.workerImageInfo.allErrors.map(
                      (item, index) => <p key={index}>{item.formatted}</p>
                    )
                  ) : (
                    <p>ー</p>
                  )}
                </div>
              </li>
            </ul>
          </div>
        </React.Fragment>
      )}
    </WorkerSettingsContext.Consumer>
  );
};

/**
 * 作業員画像設定詳細ダイアログ
 * */
const ImageSettingDialogMessage = () => {
  // 画面表示
  return (
    <WorkerSettingsContext.Consumer>
      {({ state, deleteWorkerImage, fileUpload }) => (
        <React.Fragment>
          {/*/!*作業員顔写真*!/*/}
          <FileUpload
            showEditButton
            showDeleteButton
            imageUrl={state.workerImage.imageUrl}
            alt=''
            acceptType={data.imageSettingDialog.acceptType}
            tooltipText={messageUtility.getMessage('I-000-201-01')}
            onFileUpDate={fileUpload}
            onFileDelete={() => {
              deleteWorkerImage();
            }}
            isGateKeeperEdit={true}
            info='ファイル選択時に\n写真の切り抜きが可能です。'
          />
        </React.Fragment>
      )}
    </WorkerSettingsContext.Consumer>
  );
};

const WithTooltip = ({ children, className }) => (
  <Tippy
    duration={10}
    distance={24}
    arrowType='sharp'
    delay={[100, 0]}
    placement='bottom'
    followCursor={true}
    html={<div className={Styles.toopTip}>{children}</div>}
  >
    <p className={className}>{children}</p>
  </Tippy>
);

// 定数
const data = {
  tableTitles: [
    { name: 'company_name', label: '所属会社', doSort: true },
    { name: 'primary_company_name', label: '一次協力会社', doSort: true },
    { name: 'worker_name', label: '氏名', doSort: true },
    { name: 'worker_status', label: 'ステータス', doSort: false },
    { name: 'worker_image', label: '顔写真', doSort: false },
    { name: 'register_status', label: '顔写真送信', doSort: false },
    {
      name: 'worker_image_exclusion_reason',
      label: '送信対象外理由',
      doSort: false,
    },
    { name: 'has_error', label: 'エラー状況', doSort: false },
    { name: 'detail', label: '詳細', doSort: false },
  ],
  buttonTitle: {
    confirmation: '確認',
  },
  confirmDialog: {
    title: '作業員設定詳細',
    close: '閉じる',
    workerName: '作業員名',
    companyName: '所属会社',
    workerStatus: 'ステータス',
    primaryCompanyName: '一次協力会社',
    faceImage: '顔写真送信',
    exclusionReason: '送信対象外理由',
    hasError: 'エラー状況',
  },
  imageSettingDialog: {
    title: '顔写真の登録・編集',
    buttonTitle: {
      update: '更新',
      cancel: '編集をやめる',
    },
    registerAndUpDate: '顔写真登録・編集',
    acceptType: 'image/jpeg',
  },
};



// WEBPACK FOOTER //
// ./src/components/tables/WorkerSettingsFacePictureTable.jsx